var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.size + 'px',"viewBox":"0 -960 960 960","width":_vm.size + 'px',"fill":"currentColor"}},[_c('path',{attrs:{"d":"M360-200v-80h264L160-744l56-56 464 464v-264h80v400H360Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }